// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"9a6e3ad7","142":"7bc53db5","272":"938c4dc0","292":"74961449","330":"c1e53495","357":"cf2738dd","789":"1d296ceb","832":"e2a59bc7"}[chunkId] + ".chunk.css";
};